import { Link } from "react-router-dom";

export default function Terms() {
  const updated = "December 2025";
  return (
    <>
      <section className="bg-[#0A1128] py-20 text-white sm:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E8772E]">Legal</p>
          <h1 className="mt-4 font-serif-display text-4xl font-medium leading-tight sm:text-5xl">Terms of Service</h1>
          <p className="mt-3 text-sm text-white/60">Last updated: {updated}</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <article className="space-y-8 text-[#334155]">
            <Block title="1. About these terms">
              <p>
                These Terms of Service ("Terms") govern your use of this website (the "Site") operated by <strong>PrimeCore Solutions Pvt. Ltd.</strong> ("PrimeCore", "we", "us"). By accessing or using the Site, you agree to be bound by these Terms.
              </p>
              <p>The Site is informational. It is <em>not</em> the Q-Wis software product itself; the Q-Wis software is licensed separately under a written agreement between PrimeCore and the customer.</p>
            </Block>

            <Block title="2. The Site">
              <p>We provide the Site "as is" to share information about Q-Wis and PrimeCore Solutions, allow visitors to request information or a demo, and allow authorised PrimeCore staff to manage incoming inquiries. We may add, change, or remove parts of the Site at any time without notice.</p>
            </Block>

            <Block title="3. Information accuracy">
              <p>We aim to keep all information on the Site accurate and up to date, but we do not warrant that the content is error-free. Any pricing on the Site is indicative only — final pricing is governed by a written proposal we send to you on request.</p>
            </Block>

            <Block title="4. Submitting information to us">
              <p>When you submit information through the contact or demo request form, you confirm that the information is accurate and that you are authorised to share it. We process submissions in accordance with our <Link className="text-[#E8772E] hover:underline" to="/privacy">Privacy Policy</Link>.</p>
            </Block>

            <Block title="5. Acceptable use">
              <p>You agree not to: (a) use the Site for any unlawful purpose; (b) attempt to gain unauthorised access to the Site, the admin area, or any related systems; (c) reverse engineer, scrape or copy the Site beyond standard browser caching; or (d) submit false, malicious or misleading information through any form on the Site.</p>
            </Block>

            <Block title="6. Intellectual property">
              <p>All content on the Site — including text, the PrimeCore and Q-Wis logos and word marks, design, and software — is owned by or licensed to PrimeCore Solutions Pvt. Ltd. and is protected by applicable intellectual property laws. You may not copy, reproduce or republish any content without our prior written permission.</p>
            </Block>

            <Block title="7. Third-party links and services">
              <p>The Site may link to third-party services (e.g. WhatsApp, email, Google Sign-in). We are not responsible for the content, policies or practices of those third parties.</p>
            </Block>

            <Block title="8. Disclaimer of warranties">
              <p>The Site is provided "as is" and "as available" without warranties of any kind, whether express or implied. To the maximum extent permitted by law, PrimeCore disclaims all warranties, including merchantability, fitness for a particular purpose, and non-infringement.</p>
            </Block>

            <Block title="9. Limitation of liability">
              <p>To the maximum extent permitted by law, PrimeCore Solutions Pvt. Ltd., its directors, employees and agents shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, arising out of your use of, or inability to use, the Site.</p>
            </Block>

            <Block title="10. Governing law">
              <p>These Terms are governed by the laws of Sri Lanka. Any dispute arising out of or relating to these Terms or the Site will be subject to the exclusive jurisdiction of the competent courts of Sri Lanka.</p>
            </Block>

            <Block title="11. Changes">
              <p>We may update these Terms at any time. Continued use of the Site after changes are posted constitutes your acceptance of the updated Terms.</p>
            </Block>

            <Block title="12. Contact">
              <p>Questions about these Terms? Email <a className="text-[#E8772E] hover:underline" href="mailto:info@pcoresolution.com">info@pcoresolution.com</a>.</p>
            </Block>

            <p className="text-sm text-[#64748B]">See also our <Link className="text-[#0A1128] underline hover:text-[#E8772E]" to="/privacy">Privacy Policy</Link>.</p>
          </article>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-2xl text-[#0A1128]">{title}</h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed text-[#334155]">{children}</div>
    </section>
  );
}
